import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ValidatorService, AdministrationService, CommonService } from '../../../services';
import { Location } from '@angular/common';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-users-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})

export class UsersConfigComponent implements OnInit, OnDestroy {
  limit = 20;
  id: number;
  sub: any;
  currentUserConfig: Array<any> = [];
  configs = [];
  selected = [];
  userRoles = [];
  companies = [];
  reservationCompanies = [];
  hotParkingCompanies = [];

  constructor(
    private route: ActivatedRoute,
    private administrationService: AdministrationService,
    private validatorService: ValidatorService,
    private commonService: CommonService,
    private messageService: MessageService,
    private location: Location
  ) { }

  ngOnInit() {
    this.initConfigs();
  }

  initConfigs() {
    this.configs.length = 0;
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];

      this.administrationService.getUserRoles(this.id).subscribe(
        roles => this.userRoles = roles
      );
      this.commonService.getCompanies().subscribe(
        companies => this.companies = companies,
        error => console.error("getCompanies error", error)
      );
      this.administrationService.getHotParkingCompanies(this.id).subscribe(
        companies => this.hotParkingCompanies = companies.map(c => c.id),
        error => console.error("getHotParkingCompanies error", error)
      );
      this.administrationService.getReservationCompanies(this.id).subscribe(
        companies => this.reservationCompanies = companies.map(c => c.id),
        error => console.error("getReservationCompanies error", error)
      );
      this.administrationService.getConfigByUserId(this.id)
        .subscribe(
          userConfig => {
            this.currentUserConfig = userConfig;
            this.validatorService.getAllValidationConfigs(true)
              .subscribe(
                configs => {
                  let tempList = [];
                  configs.forEach(config => {
                    config.checked = (userConfig.find(el => el && el.id === config.id) != null);
                    if (config.checked) {
                      console.log("config", config);
                      this.selected.push(config);
                    }
                    tempList.push(config);
                  });
                  this.configs = this.configs.concat(tempList);
                });
          }
        );
    });
  }

  success = false;
  failed = false;
  synchtab = [];

  displayMessage() {
    if (this.success && !this.failed) {
      this.messageService.add({ severity: 'success', summary: 'Zapisano uprawnienia', detail: 'Zapisano zmianę uprawnień do konfiguracji walidacji.' })
    }
    else if (this.success && this.failed) {
      this.messageService.add({ severity: 'warn', summary: 'Zapisano część uprawnień', detail: 'Nie wszystkie zmiany zostały zapisane. Proszę zgłosić problem do administratora.' })
    }
    else if (!this.success && this.failed) {
      this.messageService.add({ severity: 'error', summary: 'Błąd podczas zapisu uprawnień', detail: 'Podczas zapisywania zmian wystąpił błąd systemu. Proszę zgłosić problem do administratora.' })
    }
    else {
      this.messageService.add({ severity: 'info', summary: 'Brak zmian', detail: 'Brak zmian uprawnień.' })
    }
  }

  applyPermissions() {
    this.success = false;
    this.failed = false;
    if (!(this.currentUserConfig && this.currentUserConfig.some(config => !this.selected.map(c => c.id).includes(config.id))) &&
      !(this.selected.some(c => !this.currentUserConfig || !this.currentUserConfig.map(config => config.id).includes(c.id)))) {
      this.displayMessage();
      return;
    }
    this.currentUserConfig.filter(c => !this.selected.map(s => s.id).includes(c.id)).forEach(config => {
      this.synchtab.push(config);
      this.validatorService.removePermission(this.id, config.id)
        .subscribe(
          () => {
            const idx = this.currentUserConfig.findIndex(c => c.id === config.id);
            if (idx !== -1) {
              this.currentUserConfig.splice(idx, 1);
            }
            this.success = true;
            this.synchtab.pop();
            if (this.synchtab.length === 0) {
              this.displayMessage();
            }
          },
          error => {
            this.failed = true;
            this.synchtab.pop();
            if (this.synchtab.length === 0) {
              this.displayMessage();
            }
          }
        );
    });
    this.selected.filter(c => !this.currentUserConfig || !this.currentUserConfig.map(config => config.id).includes(c.id)).forEach(c => {
      this.synchtab.push(c);
      this.validatorService.addPermission(this.id, c.id)
        .subscribe(
          () => {
            this.currentUserConfig.push(c);
            this.success = true;
            this.synchtab.pop();
            if (this.synchtab.length == 0) {
              this.displayMessage();
            }
          },
          error => {
            this.failed = true;
            this.synchtab.pop();
            if (this.synchtab.length == 0) {
              this.displayMessage();
            }
          }
        );
    });
  }

  save(): void {
    this.applyPermissions();
  }

  cancel(): void {
    this.location.back();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  saveHotParkingCompanies() {
    console.log(this.hotParkingCompanies);
    this.administrationService.setHotParkingCompanies(this.id, this.hotParkingCompanies).subscribe(
      () => this.messageService.add({ severity: 'success', summary: 'Zapisano uprawnienia', detail: 'Zapisano uprawnienia do aktualizacji listy Hot Parking dla wybranych firm najemców' }),
      error => this.messageService.add({ severity: 'error', summary: 'Błąd', detail: 'Nie zapisano uprawnień do aktualizacji listy Hot Parking dla wybranych firm najemców' })
    );
  }

  saveReservationCompanies() {
    console.log(this.reservationCompanies);
    this.administrationService.setReservationCompanies(this.id, this.reservationCompanies).subscribe(
      () => this.messageService.add({ severity: 'success', summary: 'Zapisano uprawnienia', detail: 'Zapisano uprawnienia do zakładania rezerewacji w ramach wybranych firm najemców' }),
      error => this.messageService.add({ severity: 'error', summary: 'Błąd', detail: 'Nie zapisano uprawnień do zakładania rezerwacji w ramach wybranych firm najemców' })
    );
  }

  isUserInRoles(expectedRoles: string[]): boolean {
    return this.userRoles.some(r => expectedRoles.includes(r.name));
  }
}
